import React, { useEffect, useState } from 'react'
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { stripeAppearance } from '../paymentButtons.data';
import { connect, useSelector } from 'react-redux';
import CheckoutForm from '../../../../../CartPage/PaymentInfo/CheckoutForm';
import Button from '../../../../Button/Button';
import { bonusPointsStyles as styles } from "../buyPoint.tailwind";
import { STRIPE_CLIENT } from '../buyPoint.data';
import { KeyboardArrowLeft } from '@mui/icons-material';
import OverlayLoader from '../../../../Loaders/OverlayLoader/OverlayLoader';
import { showErrorSnackbar } from '../../../../../../redux/slices/snackbarSlice';

const StripeGateway = ({ clearPointIntent, closeModal, showErrorSnackbar }) => {
  const { buyPoints: paymentResponseBody } = useSelector(state => state.reward)

  const [stripePromise, setStripePromise] = useState(null);

  // Retrieve client_secret
  const clientSecret = paymentResponseBody?.client_secret; // fetch client-secret

  const stripeConfig = {
    options: {
      clientSecret,  // client-secret
      appearance: stripeAppearance, // stripe-appearance-style
      loader: "auto",
    },
    stripe: stripePromise,
  };

  useEffect(() => {
    const fetchStripe = async () => {
      try {
        const stripeInstance = await loadStripe(STRIPE_CLIENT);
        setStripePromise(stripeInstance);
      } catch (error) {
        closeModal();
        showErrorSnackbar({ title: "Payment Failed, Please refresh and try again." })
        console.log("Stripe Loading Error", error);
      }
    };
    fetchStripe();
  }, []);

  if(!stripePromise) {
    return <OverlayLoader />
  }
  
  return (
    <div className='w-full flex flex-col gap-5'>    
      <div className='flex items-center gap-3'>
        <Button variant="primary" type="button" onClick={clearPointIntent} className={`w-min justify-between !p-1`}>
          <KeyboardArrowLeft />
        </Button>

        <span className={styles.subHeading}>Purchase Points</span>
      </div>

      <Elements {...stripeConfig}>
        <CheckoutForm /> {/* Checkckout Form */}
      </Elements>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  showErrorSnackbar: (data) => dispatch(showErrorSnackbar(data)),
});

export default connect(null, mapDispatchToProps)(StripeGateway);